<template>
  <!-- Layout inner -->
  <div class="layout-inner">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">

        <div class="hd_bar">
          <div class="hd_ic ic-course"></div>
          <div class="hd_txt">
            <v-clamp class="title_txt" autoresize :max-lines="2">{{ course.title }}</v-clamp>
          </div>
        </div>

        <div class="row sub_hd_bar resource">
          <div class="col-12">
            <div class="sub_hd_ic">
              <span v-if="entity.fileType === 'assessment'" class="ic ic-assessment"></span>
              <span v-if="entity.fileType === 'video'" class="ic ic-video"></span>
              <span v-if="entity.fileType === 'pdf'" class="ic ic-file-pdf"></span>
              <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="ic ic-file-word"></span>
              <span v-if="entity.fileType === 'xlsx'" class="ic ic-file-excel"></span>
              <span v-if="entity.fileType === 'html'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'externalurl'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'other'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="ic ic-image"></span>
            </div>
            <div class="sub_hd_txt_lg">
              <v-clamp class="title_txt" autoresize :max-lines="2">{{ entity.title }}</v-clamp>
            </div>
          </div>
        </div>


        <!-- Page content -->
        <div class="container-fluid flex-grow-1 assessment_container">
          <div :style="styles.renderingArea" class="section pad-sml">
            <div id="sessionDetailByItemReport"></div>
          </div>

          <div class="float-right mt-2" v-if="isReportLoaded">
            <b-button v-on:click="navigateBack" class="btn button-primary next float-right"> done </b-button>
          </div>
        </div>

        <!-- Footer Navbar -->
        <template v-if="entityUuid">
          <course-footer-navbar :uuid="uuid" :entityUuid="entityUuid" :isTransitionPage="isTransitionPage"></course-footer-navbar>
        </template>
        <template v-else>
          <course-footer-navbar :uuid="uuid"></course-footer-navbar>
        </template>
        <!-- / Footer Navbar -->
      </div>
    </div>
  </div>
</template>

<script>
  /* global LearnosityItems LearnosityReports:true */
  import { mapState, mapActions } from 'vuex'
  import Navbar from '../../misc/components/./Navbar'
  import CourseFooterNavbar from '../../misc/components/./CourseFooterNavbar'
  import VClamp from 'vue-clamp'

  export default {
    name: 'assessment-report',
    props: ['uuid', 'entityUuid', 'attempt', 'activityId', 'sessionId', 'isTransitionPage'],
    components: {
      Navbar,
      CourseFooterNavbar,
      VClamp
    },
    data () {
      return {
        reportsApp: {},
        scoringObjects: {},
        itemsAppTeacherScoring: {},
        isReportLoaded: false,
        styles: {
          renderingArea: {
            background: '#fff',
            margin: '1rem 0'
          }
        }
      }
    },

    mounted () {
      this.initAssessmentReport()
    },

    beforeDestroy () {
      if (typeof this.reportsApp.reset === 'function') {
        this.reportsApp.reset()
      }
    },

    methods: {
      ...mapActions([
        'loadCourseDetail',
        'showAttemptReport',
        'launchManuallyGradedReportWizardForUser'
      ]),

      async initAssessmentReport () {
        await this.loadCourseDetail(this.uuid)
        this.showAttemptReport({activityId: this.activityId, sessionId: this.sessionId, courseId: this.uuid}).then(data => {
          if (data) {
            this.initializeLearnosityReports(data)
            setTimeout(() => {
              this.isReportLoaded = true
            }, 1000)
          }
        })
      },

      initializeLearnosityReports (data) {
        var self = this
        self.reportsApp = LearnosityReports.init(data, {
          'readyListener': function () {
            if (self.attempt && self.attempt.manuallyGraded) {
              self.bindReadyListener()
            }
          },
          'errorListener': function (event) {
            console.log('error: ', event)
          }
        })
      },

      bindReadyListener () {
        var itemReferences = []
        var report = this.reportsApp.getReport('sessionDetailByItemReport')
        report.on('ready:itemsApi', (itemsApp) => {
          itemsApp.getQuestions((questions) => {
            $.each(questions, (index, question) => {
              if ((question.metadata.valid_response_count === 0) && (question.metadata.rubric_reference !== undefined)) {
                var reference = question.metadata.rubric_reference
                var itemId = question.response_id + '_' + reference
                this.scoringObjects[itemId] = question
                itemReferences.push({'id': itemId, 'reference': reference})
                $('<span class="learnosity-item" data-reference="' + itemId + '">')
                  .appendTo($('#' + question.response_id).closest('.row')).wrap('<div class="teacher_scoring"></div>')
              }
            })
          })
          if (itemReferences.length > 0) {
            var itemsActivity = {
              'state': 'review',
              'type': 'feedback',
              'items': itemReferences,
              'rendering_type': 'inline',
              'session_id': this.attempt.sessionId,
              'activity_id': this.attempt.activityId
            }
            this.launchManuallyGradedReportWizardForUser(itemsActivity).then(data => {
              if (data) {
                var self = this
                self.itemsAppTeacherScoring = LearnosityItems.init(data, {
                  readyListener: function () {
                    self.generateScoreStimulus()
                  }
                })
              }
            })
          }
        })
      },

      generateScoreStimulus () {
        $.each(this.itemsAppTeacherScoring.getItems(), (index, item) => {
          const question = this.scoringObjects[index]
          const text = 'Enter score between 0-' + question.validation.max_score
          const elemId = 'stimulus-' + item.response_ids[0]
          $('#' + elemId).text(text)
        })
      },

      navigateBack () {
        let name = (this.isTransitionPage) ? 'entityResult' : 'entityDetail'
        return this.$router.push({name: name, params: {uuid: this.uuid, entityType: 'LearningContent', entityUuid: this.entityUuid}})
      }
    },

    computed: {
      ...mapState({
        'course': state => state.dashboard.course,
        'entity': state => state.dashboard.entity
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/assessment/components/AssessmentReport.vue